export default __webpack_public_path__ + "static/media/sileImg.ee52eb86.jpg";